import { render, staticRenderFns } from "./proposedAdmission.vue?vue&type=template&id=2ce364a0"
import script from "./proposedAdmission.vue?vue&type=script&lang=js"
export * from "./proposedAdmission.vue?vue&type=script&lang=js"
import style0 from "./proposedAdmission.vue?vue&type=style&index=0&id=2ce364a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports